import { Component, Input } from '@angular/core';
import { Router } from "@angular/router";
// import { MatomoTracker } from 'ngx-matomo-client';


export type GoFurtherLinkImage = 'tree-in-head' | 'coach' | 'train';

export type GoFurtherLink = {
  image: string;
  title: string;
  subTitle: string;
  description: string;
  link: string;
  isExternalLink: boolean;
  queryParams?: { [key: string]: string }
}

@Component({
  selector: 'app-go-further-links',
  templateUrl: './go-further-links.component.html',
  styleUrl: './go-further-links.component.scss'
})
export class GoFurtherLinksComponent {

  @Input() links: GoFurtherLink[] = [];

  constructor(private readonly router: Router) {
  }

  clickOnLink(link: GoFurtherLink) {
    if (link.isExternalLink) {
      window.open(link.link, "_blank");
    } else {
      (window._mtm || []).push(
        { 
          'event': 'clic-accueil-bandeau-2', 
          'nom-element': link.subTitle,
        }
      );
      this.router.navigate([link.link], { queryParams: link.queryParams });
    }
  }
}
